/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * animation.ts - helper functions for animations
 */

import { Animated, Easing, Platform } from 'react-native';


export const animateBezier = (value: Animated.Value, toValue: number) => {
  value.stopAnimation();
  Animated.timing(value, {
    toValue: toValue,
    duration: 1350,
    easing: Easing.bezier(0.19, 1, 0.22, 1),
    useNativeDriver: Platform.OS !== 'web',
  }).start();
};
